import { CssBaseline, ThemeProvider, createTheme, Box, Container } from '@mui/material';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import TermsPage from './TermsPage';
import Header from './Header';
import Footer from './Footer';
import Form from './Form';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1b8755',
    },
    info: {
      main: '#1b8755',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#0b1b32',
      secondary: '#4b5568',
    },
  },
  typography: {
    fontFamily: "'Manrope','Inter','Segoe UI','Helvetica Neue',sans-serif",
  },
  shape: {
    borderRadius: 14,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 800,
          textTransform: 'none',
        },
      },
    },
  },
});

function App() {
  const path = typeof window !== 'undefined' ? window.location.pathname : '/';
  if (path === '/privacy-policy') {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ bgcolor: 'background.default', color: 'text.primary', minHeight: '100vh' }}>
          <Header />
          <PrivacyPolicyPage />
          <Footer />
        </Box>
      </ThemeProvider>
    );
  }

  if (path === '/terms-of-service') {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ bgcolor: 'background.default', color: 'text.primary', minHeight: '100vh' }}>
          <Header />
          <TermsPage />
          <Footer />
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          bgcolor: 'background.default',
          color: 'text.primary',
        }}
      >
        <Header />
        <Container maxWidth="lg" sx={{ py: { xs: 1.5, md: 3 } }}>
          <Form />
        </Container>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default App;
